/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IAaiVisitor } from '../visitors/IAaiVisitor';
import { Node } from '../../core/models/Node';
import { IVisitor } from '../../core/visitors/IVisitor';
import { Document } from '../../core/models/Document';

/**
 * Constructor.
 * @param {Node} parent
 * @class
 * @extends Node
 * @author eric.wittmann@gmail.com
 */
export abstract class AaiServerBindings extends Node {
    public http : any;

    public ws : any;

    public kafka : any;

    public amqp : any;

    public amqp1 : any;

    public mqtt : any;

    public mqtt5 : any;

    public nats : any;

    public jms : any;

    public sns : any;

    public sqs : any;

    public stomp : any;

    public redis : any;

    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null)) {
            let __args = arguments;
            super();
            if(this.http===undefined) this.http = null;
            if(this.ws===undefined) this.ws = null;
            if(this.kafka===undefined) this.kafka = null;
            if(this.amqp===undefined) this.amqp = null;
            if(this.amqp1===undefined) this.amqp1 = null;
            if(this.mqtt===undefined) this.mqtt = null;
            if(this.mqtt5===undefined) this.mqtt5 = null;
            if(this.nats===undefined) this.nats = null;
            if(this.jms===undefined) this.jms = null;
            if(this.sns===undefined) this.sns = null;
            if(this.sqs===undefined) this.sqs = null;
            if(this.stomp===undefined) this.stomp = null;
            if(this.redis===undefined) this.redis = null;
            if(this.http===undefined) this.http = null;
            if(this.ws===undefined) this.ws = null;
            if(this.kafka===undefined) this.kafka = null;
            if(this.amqp===undefined) this.amqp = null;
            if(this.amqp1===undefined) this.amqp1 = null;
            if(this.mqtt===undefined) this.mqtt = null;
            if(this.mqtt5===undefined) this.mqtt5 = null;
            if(this.nats===undefined) this.nats = null;
            if(this.jms===undefined) this.jms = null;
            if(this.sns===undefined) this.sns = null;
            if(this.sqs===undefined) this.sqs = null;
            if(this.stomp===undefined) this.stomp = null;
            if(this.redis===undefined) this.redis = null;
            (() => {
                if(parent != null) {
                    this._parent = parent;
                    this._ownerDocument = parent.ownerDocument();
                }
            })();
        } else if(parent === undefined) {
            let __args = arguments;
            super();
            if(this.http===undefined) this.http = null;
            if(this.ws===undefined) this.ws = null;
            if(this.kafka===undefined) this.kafka = null;
            if(this.amqp===undefined) this.amqp = null;
            if(this.amqp1===undefined) this.amqp1 = null;
            if(this.mqtt===undefined) this.mqtt = null;
            if(this.mqtt5===undefined) this.mqtt5 = null;
            if(this.nats===undefined) this.nats = null;
            if(this.jms===undefined) this.jms = null;
            if(this.sns===undefined) this.sns = null;
            if(this.sqs===undefined) this.sqs = null;
            if(this.stomp===undefined) this.stomp = null;
            if(this.redis===undefined) this.redis = null;
            if(this.http===undefined) this.http = null;
            if(this.ws===undefined) this.ws = null;
            if(this.kafka===undefined) this.kafka = null;
            if(this.amqp===undefined) this.amqp = null;
            if(this.amqp1===undefined) this.amqp1 = null;
            if(this.mqtt===undefined) this.mqtt = null;
            if(this.mqtt5===undefined) this.mqtt5 = null;
            if(this.nats===undefined) this.nats = null;
            if(this.jms===undefined) this.jms = null;
            if(this.sns===undefined) this.sns = null;
            if(this.sqs===undefined) this.sqs = null;
            if(this.stomp===undefined) this.stomp = null;
            if(this.redis===undefined) this.redis = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let v : IAaiVisitor = <IAaiVisitor><any>visitor;
        v.visitServerBindings(this);
    }
}
AaiServerBindings["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiServerBindings";
AaiServerBindings["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




